import styled from "@emotion/styled";
import { fonts } from "styles/fonts";
import { colors } from "styles/colors";
import {
  MainTitle,
  Title,
  PreviewImg,
  IngredContainer,
  DirectionsWrap,
  RecipeRow,
  IngredientsWrap,
  GroupTitle,
} from "components/RecipeSteps/Preview/styled";
import { Deliver } from "styles/App.styled";
import { StarSVG, RatingContainer } from "shared/Rating/styled";
import { ButtonWrap as BtnWrap } from "shared/Button/styled";
import { ModalContainer, ModalContent, ModalWrap } from "shared/Modal/styled";

export const ModalOver = styled.div`
@media (max-width: 768px) {
  ${ModalWrap} {
    min-height: auto;
  }
  ${ModalContainer} {
    height: 100%;
    background-color: ${colors.WHITE};
  }
  ${ModalContent} {
    padding: 0;
  }
`;

export const ModalWrapper = styled.div`
  @media (max-width: 768px) {
    ${Deliver} {
      margin: 19px 0 0;
      border-bottom: none;
    }
  }
  @media (min-width: 1280px) {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ButtonWrap = styled.div`
  position: absolute;
  left: 0;
  top: 170px;
  z-index: 3;
  text-align: center;
  font-size: 18px;
`;

export const ButtonGrocery = styled.div`
  margin: 20px 0;
  @media (min-width: 769px) {
    margin: 30px 0;
  }
  button {
    width: 100%;
    @media (min-width: 640px) {
      width: auto;
    }
  }
`;

export const Wraper = styled.div`
  &.infoBtn {
    button {
      padding-left: 0;
      text-align: start;
    }
  }
  &.actionBtn {
    .download {
      color: ${colors.GREY} !important;
      border-color: ${colors.GREY_SEMILIGHT} !important;
      background-color: ${colors.WHITE} !important;
    }
  }
  &.buyBlock {
    ${BtnWrap} {
      text-align: center;
      &:disabled {
        .icon {
          stroke: ${colors.GREY} !important;
          fill: ${colors.GREY} !important;
        }
      }
    }
    .download {
      color: ${colors.GREY} !important;
      border-color: ${colors.GREY_SEMILIGHT} !important;
      background-color: ${colors.WHITE} !important;
    }
  }
  &.top {
    margin-top: 18px;
    margin-bottom: 3px;
    > * + * {
      margin-top: 6px;
    }
  }
  button {
    margin-top: 12px;
  }
  @media (max-width: 768px) {
    button {
      width: 100%;
    }
  }
  @media (min-width: 769px) {
    &.top {
      margin-bottom: 0;
      margin-top: 30px;
      > * + * {
        margin-top: 0;
      }
    }
    button {
      margin-right: 11px;
    }
  }
`;

export const WraperDesktop = styled(Wraper)`
  display: none;
  @media (min-width: 769px) {
    display: block;
    line-height: 1.75;
  }
`;
export const PreviewButtons = styled.div`
  ${Wraper} {
    button {
      margin-top: 12px;
    }
  }
  @media (min-width: 769px) {
    margin-top: auto;
    ${Wraper} {
      button {
        margin-top: 15px;
      }
    }
  }
  @media (max-width: 768px) {
    ${Wraper} {
      &:first-of-type {
        button {
          letter-spacing: 1px;
        }
      }
    }
  }
`;

export const VideoWrap = styled.div`
  position: relative;
  background-color: black;
  margin-top: 20px;
  margin-bottom: 30px;
  width: 100%;
  min-height: 185px;
  video {
    width: 100%;
  }
  @media (min-width: 361px) {
    height: 328px;
  }
  @media (min-width: 1024px) {
    height: 594px;
    margin-bottom: 20px;
    video {
      width: 100%;
      height: 100%;
    }
  }
`;

export const VideoConversionWrap = styled.div`
  position: relative;
  background-color: silver;
  margin-top: 20px;
  margin-bottom: 30px;
  width: 100%;
  min-height: 185px;
  @media (min-width: 361px) {
    height: 328px;
  }
  @media (min-width: 1024px) {
    height: 594px;
    margin-bottom: 20px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  flex-direction: column;
`;

export const IconWrap = styled.div`
  cursor: pointer;
  position: relative;
  width: 22px;
  height: 22px;
  margin-top: 3px;
  @media (min-width: 769px) {
    margin-top: 12px;
  }
  .icon {
    width: 100%;
    height: 100%;
  }
`;

export const TitleWrap = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 20px;
  margin-bottom: 27px;
  border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
  ${MainTitle} {
    flex: 1;
  }
  @media (min-width: 769px) {
    margin-bottom: 20px;
    ${MainTitle} {
      align-self: center;
      padding-right: 16px;
    }
  }
  ${Wraper} {
    display: flex;
    margin-left: auto;
    align-items: self-start;
    button {
      padding-left: 12px;
      padding-right: 12px;
      margin: 0;
    }
    button + ${IconWrap} {
      margin-left: 29px;
    }
  }
`;

export const TitleWrapVideo = styled(TitleWrap)`
  @media (max-width: 768px) {
    border-bottom: none;
    margin-top: 30px;
    padding: 0;
  }
  margin-bottom: 20px;
`;
export const BlurRecipe = styled.div`
  display: none;
  backdrop-filter: blur(20px);
  left: 0;
  top: 0;
  position: absolute;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  @media (min-width: 769px) {
    height: 550px;
  }
`;

export const BlurRecipeContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
export const Text = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;
  font-family: ${fonts.robotoNormal};
  padding: 0 20px;
  font-size: 18px;
  text-align: center;
  max-width: 790px;
`;

export const WraperBuy = styled.div`
  @media (max-width: 769px) {
  }
`;

export const SliderBuy = styled.div``;

export const MainWrap = styled.div`
  ${PreviewImg} {
    &> div {
      width: 100% !important;
      height: 100% !important;
    }
  }
    img {
      border-radius: 0;
    }
  }
`;

export const RecipeColumnDirections = styled.div`
  margin-top: 15px;
  position: relative;
  @media (max-width: 769px) {
    padding-bottom: 150px;
  }
  @media (min-width: 1024px) {
    margin-top: 0;
    flex: 0 0 59%;
    max-width: 59%;
  }
  ${IngredContainer} + ${IngredContainer} {
    margin-top: 21px;
  }
  ${DirectionsWrap} + ${DirectionsWrap} {
    margin-top: 21px;
  }
`;

export const RecipeColumnIngredients = styled.div`
  @media (min-width: 1024px) {
    flex: 0 0 41%;
    max-width: 41%;
    padding-right: 30px;
  }
  ${IngredContainer} + ${IngredContainer} {
    margin-top: 21px;
  }
`;

export const RecipeRowSlide = styled(RecipeRow)`
  margin-top: 30px !important;
  margin-bottom: 180px !important;

  ${Title} {
    margin-bottom: 22px;
    line-height: 1.2;
  }
  ${IngredientsWrap} + ${IngredientsWrap} {
    margin-top: 22px;
    @media (min-width: 1024px) {
      margin-top: 32px;
    }
  }
  ${DirectionsWrap} + ${GroupTitle} {
    margin-top: 33px;
  }
  @media (max-width: 768px) {
    ${RecipeColumnDirections} {
      margin-top: 30px;
      ${Title} {
        margin-bottom: 32px;
      }
    }
  }
  @media (min-width: 769px) {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding: 0;
    ${Title} {
      margin-bottom: 32px;
    }
  }
`;

export const CollectionsTitle = styled.div`
  font-family: ${fonts.abhayaRegular};
  color: ${colors.HOME_HEADERS};
  font-size: 30px;
  margin-bottom: 24px;
  margin-top: 30px;
`;

export const DirectionMask = styled.div`
  height: 12px;
  width: ${(props) => props.width}%;
  background-color: ${colors.GREY_LIGHT};
  margin-bottom: 10px;
  border-radius: 20px;
`;

export const MaskWrapper = styled.div`
  margin-bottom: 30px;
`;

export const EquipmentTitle = styled.h2`
  padding-bottom: 20px;
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  border-bottom: 1px solid ${colors.GREY_LIGHT};
  margin-bottom: 0px;
`;

export const EquipmentWrap = styled.div`
  margin-bottom: 20px;
`;

export const EquipmentItem = styled.div`
  font-size: 14px;
  font-family: ${fonts.latoBold};
  color: ${colors.GREY_DARK};
  border-bottom: 1px solid ${colors.GREY_LIGHT};
  padding: 10px 0px 15px 0px;
`;

export const BackToCollection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  background: ${colors.GREY_LIGHT};
  padding: 20px 30px;
  border-radius: 10px;
  color: ${colors.RED};
  cursor: pointer;
  .icon {
    stroke: ${colors.RED};
  }
`;

export const BackText = styled.div`
  margin-left: 10px;
  font-size: 16px;
  font-family: ${fonts.latoRegular};
`;

export const RatingWrapDesktop = styled.div`
  display: none;
  @media (min-width: 769px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    ${RatingContainer} {
      margin-left: 5px;
    }
    ${StarSVG} {
      width: 15px;
      height: 15px;
      stroke: ${(props) => (props.hasReviews ? colors.STAR_ORANGE : colors.GREY)};
    }
  }
`;

export const RatingText = styled.div`
  color: ${colors.GREY_100};
`;

export const RatingWrapMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: -5px;

  ${RatingText} {
    margin: 10px 0px -5px 5px;
  }

  ${StarSVG} {
    width: 15px;
    height: 15px;
    stroke: ${(props) => (props.hasReviews ? colors.STAR_ORANGE : colors.GREY)};
  }
`;

export const BtnToolbarWrapMobile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
`;
export const Redlink = styled.a`
  color: ${colors.RED};
  padding-left: 5px;
  padding-right: 5px;
  display: contents;
  cursor: pointer;
`;

export const AddToGroceryWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  ${Title} {
    margin: 0px;
  }

  ${BtnWrap} {
    width: auto;

    ${(props) =>
      props.isInactive &&
      `
      background-color: ${colors.GREY_LIGHT} !important;
      color: ${colors.GREY} !important;
      .icon {
        stroke: ${colors.GREY} !important;
        fill: ${colors.GREY} !important;
      }
    `}

    ${(props) =>
      props.isInGrocery &&
      `
        background-color: ${colors.GREEN_LIGHT} !important;
        border: 1px solid ${colors.WHITE} !important;
        color: ${colors.GREEN} !important;
        .icon {
          stroke: ${colors.GREEN} !important;
          fill: ${colors.GREEN} !important;
        }
    `}
  }
`;

export const ServingsText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
  font-size: 14px;
  font-family: ${fonts.latoBold};

  &:not(.third) {
    text-transform: lowercase;
  }

  .icon {
    margin-right: 5px;
  }

  @media (min-width: 769px) {
    font-size: 16px;
  }
`;

export const ServingsLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .first {
    order: 1;
  }
  .second {
    order: 2;
  }
  .third {
    order: 3;
  }

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;

    .first {
      order: 1;
    }
    .second {
      order: 2;
    }
    .third {
      order: 3;
    }
  }
`;

export const ServingsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${colors.GREY_SEMILIGHT};
  margin-top: 10px;
  padding-top: 10px;

  @media (min-width: 769px) {
    padding-top: 5px;
  }
`;

export const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    width: 4em;
    height: 4em;
  }
`;
